import cx from "classnames";

import { Heading } from "common/ui/Heading";
import { Skeleton } from "common/ui/Skeleton";

import styles from "./Tabs.module.scss";

interface Props {
  items: {
    onClick: () => void,
    header: string,
    id: string
  }[],
  selectedId: string,
  isLoading?: boolean
}

function Tabs({ items, selectedId, isLoading } : Props) {
  return (
    <div className={styles.Tabs}>
      {items?.map((i, idx) => (
        <div
          key={idx}
          className={cx(styles.Tab, {
            [styles.Selected]: isLoading ? idx === 0 : i.id === selectedId,
          })}
          onClick={i.onClick}
        >
          {isLoading
            ? <Skeleton type="h4" width={100} />
            : <Heading variant="h4">{i.header}</Heading>
          }
        </div>
      ))}
    </div>
  )
};

export { Tabs };
